(() => {
  class GamedayCouchFeature extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-couch-feature-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-couch-feature-panel]'));
      this.cue = this.querySelector('[data-couch-feature-cue]');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.couchFeatureTab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    activate(step, moveFocus = false) {
      const activeTab = this.tabs.find((tab) => tab.dataset.couchFeatureTab === step);
      if (!activeTab) return;

      this.dataset.activeStep = step;
      this.tabs.forEach((tab) => {
        const active = tab === activeTab;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const active = panel.dataset.couchFeaturePanel === step;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      if (this.cue) this.cue.textContent = activeTab.dataset.cue || step;
      if (moveFocus) activeTab.focus();
    }

    onKeydown(event, currentIndex) {
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      if (nextIndex === null) return;
      event.preventDefault();
      this.activate(this.tabs[nextIndex].dataset.couchFeatureTab, true);
    }
  }

  if (!customElements.get('gameday-couch-feature')) {
    customElements.define('gameday-couch-feature', GamedayCouchFeature);
  }
})();
